import { useCallback, useState } from "react";
import { CommonSelectProps, SelectBase } from "../common/SelectBase";
import { Option } from "../common/SelectBase";
import { SingleSelectOptions } from "./SingleSelectOptions";
import { SingleTriggerValue } from "./SingleTriggerValue";

export interface SingleSelectProps extends CommonSelectProps {
  /**
   *  Array of selectable item values
   */
  options: Option[];
  /**
   * Callback when the selected value changes
   */
  onChange: (value: string) => void;
  /**
   * Selected option
   */
  selectedOption?: Option;
}

export function SingleSelect({
  options,
  selectedOption,
  onChange,
  ...rest
}: SingleSelectProps) {
  const [open, setOpen] = useState(false);

  const handleOptionSelect = useCallback(
    (option: Option) => {
      onChange(option.value);
      setOpen(false);
    },
    [onChange]
  );

  return (
    <SelectBase
      {...rest}
      isPopoverOpen={open}
      setIsPopoverOpen={setOpen}
      handleTogglePopover={() => setOpen((prev) => !prev)}
      triggerContent={
        <SingleTriggerValue
          value={selectedOption?.label ?? ""}
          placeholder={rest.placeholder}
        />
      }
      popoverContent={
        <SingleSelectOptions
          options={options}
          selectedOption={selectedOption}
          onOptionSelect={handleOptionSelect}
        />
      }
    />
  );
}
